import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "./App";

const QuickFunds = () => {
  const { theme } = useContext(ThemeContext);
  const [spotBalance, setSpotBalance] = useState(0);
  const [loanStatus, setLoanStatus] = useState("");
  const [timer, setTimer] = useState(0);
  const [loanActive, setLoanActive] = useState(false);

  // Project colors (match Funds.js)
  const colors = {
    background: theme === "dark" ? "#121212" : "#f2f4f8",
    card: theme === "dark" ? "#333" : "#fff",
    border: theme === "dark" ? "#444" : "#e0e0e0",
    boxShadow: theme === "dark"
      ? "0 8px 20px rgba(255,255,255,0.15)"
      : "0 8px 20px rgba(0,0,0,0.15)",
    text: theme === "dark" ? "#f1f1f1" : "#333",
    accent: theme === "dark" ? "#1e88e5" : "#007bff",
    inputBg: theme === "dark" ? "#232323" : "#fff",
    inputBorder: theme === "dark" ? "#444" : "#ddd",
    modalBg: theme === "dark" ? "#232323" : "#fff",
    modalText: theme === "dark" ? "#f1f1f1" : "#333",
    modalBoxShadow: theme === "dark"
      ? "0 8px 20px rgba(255,255,255,0.15)"
      : "0 8px 20px rgba(0,0,0,0.15)",
  };

  useEffect(() => {
    // Fetch user's spot balance
    const userId = localStorage.getItem("userId");
    if (!userId) return;
    fetch(`https://tradespots.online/api/auth/user/${userId}`)
      .then(res => res.json())
      .then(data => {
        if (data.user && typeof data.user.spotBalance === "number") {
          setSpotBalance(data.user.spotBalance);
        }
      });
  }, []);

  // Calculate 5% of spotBalance, rounded to 4 decimals, minimum 0.0001 if >0
  const eligibleLoan = spotBalance > 0 ? Math.max(0.0001, Math.floor(spotBalance * 0.05 * 10000) / 10000) : 0;

  const handleApplyLoan = async () => {
    if (spotBalance <= 0) {
      setLoanStatus("You need a positive SPOT balance to apply for a loan.");
      return;
    }
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setLoanStatus("User not logged in.");
      return;
    }
    setLoanStatus("Processing loan...");
    // Call backend to credit loan (SPOT only)
    const res = await fetch("https://tradespots.online/api/funds/quick-loan", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId, amount: eligibleLoan })
    });
    const data = await res.json();
    if (data.success) {
      setLoanStatus(`Loan of ${eligibleLoan} SPOT credited! It will be auto-deducted in 10 minutes.`);
      setLoanActive(true);
      setTimer(600); // 10 minutes in seconds
    } else {
      setLoanStatus(data.error || "Loan failed.");
    }
  };

  // Timer countdown
  useEffect(() => {
    let interval;
    if (loanActive && timer > 0) {
      interval = setInterval(() => setTimer(t => t - 1), 1000);
    } else if (timer === 0 && loanActive) {
      setLoanStatus("Loan period ended. Amount will be auto-deducted.");
      setLoanActive(false);
    }
    return () => clearInterval(interval);
  }, [loanActive, timer]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: colors.background,
        color: colors.text,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', sans-serif",
        padding: 24,
      }}
    >
      <button
        onClick={() => window.history.length > 1 ? window.history.back() : window.location.assign('/funds')}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: colors.accent,
          color: "#fff",
          border: "none",
          borderRadius: 8,
          padding: "8px 16px",
          fontWeight: "bold",
          fontSize: 16,
          cursor: "pointer",
          boxShadow: colors.boxShadow,
          zIndex: 10,
        }}
      >
        ← Back
      </button>
      <div
        style={{
          background: colors.card,
          borderRadius: 16,
          boxShadow: colors.boxShadow,
          border: `1px solid ${colors.border}`,
          padding: 32,
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: colors.accent, marginBottom: 16 }}>Quick Funding</h2>
        <div style={{ marginBottom: 16 }}>
          <strong>Your SPOT Balance:</strong>
          <div style={{ fontSize: 22, margin: 8 }}>{spotBalance} SPOT</div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <strong>Eligible Loan (5%):</strong>
          <div style={{ fontSize: 22, margin: 8 }}>{eligibleLoan} SPOT</div>
        </div>
        <button
          onClick={handleApplyLoan}
          disabled={loanActive || spotBalance <= 0}
          style={{
            backgroundColor: colors.accent,
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "12px 24px",
            fontSize: 16,
            fontWeight: "bold",
            cursor: loanActive || spotBalance <= 0 ? "not-allowed" : "pointer",
            marginBottom: 16,
            width: "100%",
            transition: "background-color 0.3s",
            opacity: loanActive || spotBalance <= 0 ? 0.7 : 1,
          }}
        >
          {loanActive ? "Loan Active" : "Apply for Quick Loan"}
        </button>
        {loanActive && (
          <div style={{ margin: "12px 0", color: colors.accent, fontWeight: "bold" }}>
            Time left: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, "0")}
          </div>
        )}
        {loanStatus && (
          <div style={{ marginTop: 12, color: loanActive ? colors.accent : "red", fontWeight: "bold" }}>{loanStatus}</div>
        )}
      </div>
    </div>
  );
};

export default QuickFunds;
